module.exports = __webpack_public_path__ + "static/media/img_top_main1@2x.3c202b8b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_top_main1@2x.webp
// module id = 772
// module chunks = 0